const DisabledInputStyle = {
  disabled: {
    color: "black"
  }
};

export default DisabledInputStyle;
